export default __webpack_public_path__ + "static/media/fsiRealCase1-mobile.40524d04.jpg";